export default __webpack_public_path__ + "static/media/ic-refresh.c362dfcb.svg";